import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '../modals/apiresponse';
import * as CryptoJS from 'crypto-js';
import { PersistenceService, StorageType } from 'angular-persistence';
import { localStorageInformationId, storeInformationId, systemConstants } from '../modals/common';
import { LoaderService } from './loader.service';
import { switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromApp from '../../store/app.reducer';
import { Permission } from 'app/permissions/store/permission.model';
import { Observable } from 'rxjs';
import { ApexYAxis } from 'ng-apexcharts';


@Injectable({
  providedIn: 'root'
})

export class BaseService {
  key = CryptoJS.enc.Utf8.parse('wjmJIY2zScly1bctD26fDIN6nUJ4Qavn');
  iv = CryptoJS.enc.Utf8.parse('wjmJIY2zScly1bct');
  state;

  pagePermissions: Permission;


  constructor(protected _http: HttpClient, private router: Router,
    private store: Store<fromApp.AppState>,
    private persistanceService: PersistenceService, private loaderService: LoaderService) {
  }


  callSecureAPI(method: string, url: string, body?: any, loader: boolean = true): Observable<any> {
    if (loader) { 
      this.loaderService.showLoader(); 
    }


    const userdata = this.getLocalData(localStorageInformationId.userTokenInfo);
    let headers = new HttpHeaders({
      'AuthenticationKey': 'NetVidyalaya@123',
      'OrgId': userdata.orgId.toString(),
      'Authorization': `bearer ${this.getToken()}`,
      'content-type': 'application/json'
    });

    // call to an api to check logged-in user's session
    var http = this.callGetAPI('/Common/OrgId');

    return http.pipe(
      switchMap(res => {
        console.log(res);
        if (res > 0) {
          return this._http.request<ApiResponse>(
            new HttpRequest(method, systemConstants.domain + url, `"${this.Encrypt(JSON.stringify(body))}"`,
              { headers })).pipe(
                tap( // Log the result or error
                  data => {
                    if (data.type === 4) {
                      if (loader) {
                        this.loaderService.hideLoader();
                      }
                    }
                  },
                  error => {
                    if (error.status === 401) {
                      this.setLocalData('log', JSON.stringify(error));
                      window.location.href = systemConstants.webSiteUrl + '/Pages/Baseframework/Security/Login';
                    }
                    if (loader) {
                      this.loaderService.hideLoader();
                    }
                  }
                )
              );
        } else {
          // navigate to login if session expired
          var loginPageUrl = 'Pages/Baseframework/Security/Login';
          window.location.href = loginPageUrl;
        }
      })
    );
  }



  callUploadAPI(method: string, url: string, body?: FormData, loader: boolean = true) {
    if (loader) { 
      this.loaderService.showLoader(); 
    }

    const userdata = this.getLocalData(localStorageInformationId.userTokenInfo);
    const headers = new HttpHeaders({
      'AuthenticationKey': 'NetVidyalaya@123',
      'OrgId': userdata.orgId.toString(),
      'Authorization': `bearer ${this.getToken()}`
    });

    return this._http.request<ApiResponse>(
      new HttpRequest(method, systemConstants.domain + url, body,
        { headers })).pipe(
          tap( // Log the result or error
            data => {
              if (data.type === 4) {
                if (loader) { 
                  this.loaderService.hideLoader(); 
                }
              }

            },
            error => {
              if (error.status === 401) {
                this.setLocalData('log', JSON.stringify(error));
                window.location.href = systemConstants.webSiteUrl + '/Pages/Baseframework/Security/Login';
              }
              if (loader) { 
                this.loaderService.hideLoader(); 
              }
            }
          )
        );
  }

  callOpenAPI(method: string, url: string, body?: any) {
    const userdata = this.getLocalData(localStorageInformationId.userTokenInfo);
    const headers = new HttpHeaders({
      'AuthenticationKey': 'NetVidyalaya@123',
      'OrgId': userdata.orgId.toString(),
    });
    return this._http.request(
      new HttpRequest(method, systemConstants.domain + url, body,
        { headers, responseType: 'text' })).pipe(
          tap( // Log the result or error
            data => {

            },
            error => { 
              this.loaderService.hideLoader();
             }
          )
        );
    ;

  }

  AddActivityLog(orgId: number, userId: number, ScreenId: number, Activity: string, RecordSourceId: number, RecordDetail: string, SourceTypeId: number) {
    const body = {
      OrgId: orgId,
      UserId: userId,
      SessionId: 0,
      ScreenId: ScreenId,
      Activity: Activity,
      RecordSourceId: RecordSourceId,
      RecordDetail: RecordDetail,
      SourceTypeId: 2023
    };

    this.callSecureAPI('POST', '/CommonDll/CreateAuditActivityLog', body);

  }

  getReposnse(res) {
    if (res['body'] !== '' && res['body'] !== undefined) {
      if (res['body']['StatusCode'] === 401) {
        this.setLocalData('log', JSON.stringify(res));
        window.location.href = systemConstants.webSiteUrl + '/Pages/Baseframework/Security/Login';
      }
      if (res['body']['data'] != null && res['body']['data'] != '') {
        // this.loaderService.hideLoader();
        return JSON.parse(this.Decrypt(res['body']['data']));
      }
      // this.loaderService.hideLoader();  
    }
  }

  // getStoreInfo(type) {
  //   this.store.select(e => e[type]).subscribe((data) => this.state = data);;
  //   const token = this.state;
  //   return token[type];
  // }

  // setStoreInfo(type, info) {
  //   switch (type) {
  //     case 'tokenInformation':
  //       this.store.dispatch(new TokenInformationActions.AddTokenInformation(info));
  //       break;
  //     case 'loggedInUserInformation':
  //       this.store.dispatch(new LoggedInUserInformationActions.AddLoggedInUserInformation(info));
  //       break;
  //   }

  // }

  // getTokenInfo() {
  //   this.store.select(e => e.tokenInformation).subscribe((data) => this.state = data);;
  //   const token = this.state;
  //   return token['tokenInformation'];
  // }



  Encrypt(str) {
    const encrypted = CryptoJS.AES.encrypt(str, this.key, {
      iv: this.iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });

    const result = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    return result;
  }

  Decrypt(str) {
    var decrypted = CryptoJS.AES.decrypt(str, this.key, { iv: this.iv });
    // console.log(decrypted.toString(CryptoJS.enc.Utf8));
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  setLocalData(id, info) {
    this.persistanceService.set(id, this.Encrypt(JSON.stringify(info)), { type: StorageType.LOCAL });
  }

  getLocalData(id) {
    const encryptedLocalData = this.persistanceService.get(id, StorageType.LOCAL);
    if (encryptedLocalData != '' && encryptedLocalData != undefined) {
      // console.log(this.Decrypt(encryptedLocalData));
      return JSON.parse(this.Decrypt(encryptedLocalData));
    }
  }

  getToken() {
    return document.cookie.split(';').filter(e => e.split('=')[0].trim() === 'UserDetailToken').map(e => e.split('=')[1])[0];
  }
  // Date Methods 

  calcDate(date1, date2) {
    var diff = Math.floor(date1.getTime() - date2.getTime());
    var day = 1000 * 60 * 60 * 24;

    var days = Math.floor(diff / day);
    var months = Math.floor(days / 31);
    var years = Math.floor(months / 12);

    var message = date2.toDateString();
    message += " was "
    message += days + " days "
    message += months + " months "
    message += years + " years ago \n"

    return { day: days, month: months, year: years };
  }

  getScreenId() {
  }

  getStoreData(Id): Observable<any> {
    return this.store.select(Id);

  }

  

  callAPIWithPromis<T>(url: string, body: any): Promise<T> {
    const userdata = this.getLocalData(localStorageInformationId.userTokenInfo);
    let headers = new HttpHeaders({
      'AuthenticationKey': 'NetVidyalaya@123',
      'OrgId': userdata.orgId.toString(),
      'Authorization': `bearer ${this.getToken()}`,
      'content-type': 'application/json'
    });
    return this._http.post<T>(systemConstants.domain + url, `"${this.Encrypt(JSON.stringify(body))}"`, { headers }).toPromise();
  }

 // ::NOTE:: just to call 'Common/OrgId' method, cannot be used for other http call because of difference in api base URL
 callGetAPI<T>(url: string) {
  const userdata = this.getLocalData(localStorageInformationId.userTokenInfo);
  let headers = new HttpHeaders({
    'AuthenticationKey': 'NetVidyalaya@123',
    'OrgId': userdata.orgId.toString(),
    'Authorization': `bearer ${this.getToken()}`,
    'content-type': 'application/json'
  });
  return this._http.get<T>(`${window.location.protocol}//${window.location.host}` + url, { headers });
}
}
